<template>
  <vs-prompt buttons-hidden	class="large" title="إضافة سؤال من بنك الاسئلة" :active="active" @close="close">
    <div id="upload-questions" class="question-banks-app border border-solid d-theme-border-grey-light rounded vs-con-loading__container">

      <div class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

        <!-- SEARCH BAR -->
        <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">
          <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleQuestionBankSidebar(true)"/>
          <vs-input icon-no-border icon="icon-search" size="large" icon-pack="feather" placeholder="بحث..." v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
        </div>

        <VuePerfectScrollbar class="question-banks-content-scroll-area bg-white" :settings="settings" ref="question-banksListPS" :key="$vs.rtl">
          <transition-group name="list-enter-up" class="question-banks__question-banks" tag="ul" appear>
            <li class="cursor-pointer question-banks__question-bank-item" v-for="(questionBank, index) in questionBanks" :key="(questionBank.id)" @click="openQuestionBank(questionBank.id)" :style="{transitionDelay: (index * 0.1) + 's'}">
              <question-bank-item view-only :data="questionBank"/>
            </li>
          </transition-group>
        </VuePerfectScrollbar>
      </div>

      <question-bank-view
        view-only
        :openQuestionBankId   = "openQuestionBankId"
        :isSidebarActive      = "isQuestionBankView"
        @closeSidebar         = "closeQuestionBankViewSidebar"
        @selectedQuestions    = "selectedQuestionsObserver"
        :parent               = "'#upload-questions'"
        @close                = "close">
      </question-bank-view>
    </div>

    <div class="flex justify-end mt-4">
      <vs-button @click="close" type="flat">رجوع</vs-button>
      <vs-button v-if="isQuestionBankView" @click="uploadQuestions" class="ml-2">إضافة الأسئلة</vs-button>
    </div>
  </vs-prompt>
</template>

<script>
    import QuestionBanksSidebar from '@/views/questionBanks/QuestionBanksSidebar.vue'
    import QuestionBankItem from '@/views/questionBanks/QuestionBankItem.vue'
    import QuestionBankView from '@/views/questionBanks/QuestionBankView.vue'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import QuestionsBankForm from '@/views/questionBanks/QuestionsBankForm'

    export default {
        name: 'UploadQuestions',
        components: {
            QuestionBankItem,
            QuestionBanksSidebar,
            QuestionBankView,
            QuestionsBankForm,
            VuePerfectScrollbar
        },
        props: {
            active: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                filter: {
                    term: 'current',
                    type: [],
                },
                selectedQuestions    : [],
                openQuestionBankId   : null,
                clickNotClose        : true,
                isQuestionBankView   : false,
                settings             : {
                    maxScrollbarLength : 60,
                },
                questionBank: {},
                searchQuery: '',
            }
        },
        computed: {
            questionBanks() {
                return this.$store.state.questionBanks.all.filter(questionBank => {
                    return questionBank.title.includes(this.searchQuery)
                        && (this.filter.type.length > 0 ? this.filter.type.includes(questionBank.type) : true)
                        && (this.filter.term === 'current' ? questionBank.is_current_term : !questionBank.is_current_term)
                })
            },
        },
        methods: {
            uploadQuestions(){
                this.$emit('selectedQuestions', this.selectedQuestions)
                this.close()
            },
            selectedQuestionsObserver(questions){
                this.selectedQuestions = questions
            },
            openQuestionBank(id) {
                this.openQuestionBankId = id
                this.isQuestionBankView = true
            },
            closeQuestionBankViewSidebar() {
                this.isQuestionBankView = false
            },
            close(){
                this.closeQuestionBankViewSidebar()
                this.$emit('update:active', false)
            }
        },
        created(){
            this.$store.dispatch('questionBanks/load')
        },
    }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/apps/questionBanks.scss";

  #upload-questions {
    .no-scroll-content {
      height: calc(var(--vh, 1vh) * 100 - 14.1rem) !important;
    }
    .full-vs-sidebar .vs-sidebar {
      margin-left: 0 !important;
      max-width: 100% !important;
    }
  }
</style>
